import { clarity } from "@/_old/lib/clarity";
import { clevertap } from "@/_old/lib/clevertap";
import { hotjar } from "@/_old/lib/hotjar";
import { useCallback, useEffect } from "react";
import { identifyDatadogUser } from "@/core/config/datadog-rum";
import { UserInfo } from "../types";
import { userGuiding } from "@/_old/lib/user-guiding";
import { useFlagsmith } from "flagsmith/react";

export const useInitProviders = (userInfo: UserInfo) => {
  const flagsmith = useFlagsmith();

  const hotjarIdentify = useCallback(() => {
    const {
      user: { id, first_name, last_name, company_name },
      profile: { phone, email },
      league: { name: leagueName },
    } = userInfo;

    hotjar.identify(`${id}`, {
      companyName: company_name || leagueName,
      userEmail: email,
      userName: `${first_name} ${last_name}`,
      userPhone: phone,
    });
  }, [userInfo]);

  const claritydentify = useCallback(() => {
    clarity.initialize();

    const {
      user: { id },
      profile: { email },
    } = userInfo;

    clarity.identifyClarity({
      userId: `${id}`,
      email: email,
    });
  }, [userInfo]);

  const userGuidingdentify = useCallback(() => {
    const {
      user: { id },
      league: { id: company_id },
      profile: { role },
      league: { exclusive_spaces },
    } = userInfo;

    const user_role = role.includes("admin-co") ? "manager" : "submanager";

    userGuiding.identifyUserGuiding(
      id.toString(),
      company_id,
      exclusive_spaces.length > 0,
      user_role,
    );
  }, [userInfo]);

  const cleverTapIdentify = useCallback(() => {
    clevertap.identity({
      email: userInfo.profile.email,
      name: `${userInfo?.user?.first_name} ${userInfo.user.last_name}`,
      id: userInfo.user.id,
    });
  }, [userInfo]);

  const flagsmithIdentify = useCallback(async () => {
    const {
      league: { id: company_id },
    } = userInfo;

    flagsmith.identify(company_id.toString(), {
      companyId: company_id.toString(),
    });
  }, [userInfo]);

  const datadogIdentify = useCallback(() => {
    identifyDatadogUser({
      id: userInfo.user.id.toString(),
      email: userInfo.profile.email,
      name: `${userInfo.user.first_name} ${userInfo.user.last_name}`,
      league: userInfo?.league?.id || 0,
    });
  }, [userInfo]);

  useEffect(() => {
    datadogIdentify();
  }, [datadogIdentify]);

  useEffect(() => {
    flagsmithIdentify();
  }, [flagsmithIdentify]);

  useEffect(() => {
    hotjarIdentify();
  }, [hotjarIdentify]);

  useEffect(() => {
    userGuidingdentify();
  }, [userGuidingdentify]);

  useEffect(() => {
    claritydentify();
  }, [claritydentify]);

  useEffect(() => {
    cleverTapIdentify();
  }, [cleverTapIdentify]);
};
